import { render, staticRenderFns } from "./GenreListButton.vue?vue&type=template&id=9c2c9834&"
import script from "./GenreListButton.vue?vue&type=script&lang=js&"
export * from "./GenreListButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports